import { notification } from 'antd';

import './notification.css';

export default (type, message, description, btn) => {
    notification[type]({
        message,
        description,
        className: type,
        btn,
    });
};


// WEBPACK FOOTER //
// ./src/App/components/notification/notification.js